import React, {Component} from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import InlineEditor from '@ckeditor/ckeditor5-build-inline';
import {connect} from 'react-redux';
// import StrapiUploadAdapter from '@martinkronstad/ckeditor5-strapi-upload-adapter';
import StrapiUploadAdapter from './StrapiUploadAdapter';
import axios from 'axios';

//https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/react.html
class CustomCKEditor extends Component {
  render () {
    let {type, activeTemplate, content, customizeTextHandler} = this.props;
    if (!activeTemplate || typeof activeTemplate === 'undefined') {
      activeTemplate = '0';
    }
    let {nineToKnowContent, canEditContent} = this.props.form;
    if (activeTemplate === '0') {
      if(nineToKnowContent && typeof nineToKnowContent === 'object'){
        content = nineToKnowContent[type];
      }
      if(!content){
        if(type === 'topMid'){
          content =`<br/>Welcome to 9 To Know, a quick and easy way to take a look into your financial future.
              <br/><br/>
              Here you can obtain a complimentary basic financial analysis by entering 9 pieces of contact and financial information.
              <br/><br/>
              This analysis can help determine if you are on track for a successful retirement or if you may come up short. If you find the analysis doesn’t match your desired results, your advisor could provide recommendations that may help you attain your financial goals and improve your retirement picture.<br/>`;
        }
        else{
          content ="";
        }
      }
    }
    // if(!canEditContent){
    //     return(
    //         <div className="row">
    //             <div className='col-md-12 col-sm-12'>
    //                 <div dangerouslySetInnerHTML={{ __html: content }} />
    //             </div>
    //         </div>
    //     );
    // }
    return (
      <div className="CustomCKEditor">
        <CKEditor
          editor={InlineEditor}
          data={content}
          onInit={editor => {
            // You can store the "editor" and use when it is needed.
            // console.log( 'Editor is ready to use!', editor );
            if (!canEditContent) editor.isReadOnly = true;
          }}
          onChange={(event, editor) => {
            // const data = editor.getData();
            // console.log('onchange', { event, editor, data } );
          }}
          onBlur={(event, editor) => {
            if (activeTemplate === '0') {
              axios({
                method: 'post',
                url: '/92know/admin/content',
                data: { type: this.props.type, content: editor.getData() }
              }).then(response => {});
            } else {
              customizeTextHandler(editor.getData());
            }
          }}
          onFocus={(event, editor) => {
            // console.log( 'Focus.', editor );
          }}
          config={{
            placeholder: canEditContent ? 'Type the content here!' : '',
            extraPlugins: [StrapiUploadAdapter],
            strapiUploadAdapter: {
              uploadUrl: `/92know/admin/upload`,
              type: 'type'
              //   absUrl: `http://`,
              //   headers: {
              //     Authorization: "Bearer tokeksadf"
              //   }
            },
            alignment: {
              options: ['left', 'right', 'center']
            },
            toolbar: {
              items: [
                'heading',
                '|',
                'bold',
                'italic',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'insertTable',
                '|',
                'imageUpload',
                '|',
                'undo',
                'redo',
                'alignment'
              ]
            },
            image: {
              resizeUnit: 'px',
              toolbar: [
                'imageTextAlternative',
                '|',
                'imageStyle:alignLeft',
                'imageStyle:full',
                'imageStyle:alignRight'
              ],
              styles: [
                // This option is equal to a situation where no style is applied.
                'full',
                'side',
                // This represents an image aligned to the left.
                'alignLeft',
                'alignCenter',
                // This represents an image aligned to the right.
                'alignRight'
              ]
            },
            table: {
              contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
            },
            language: 'en'
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.mainState,
    ...ownProps
  }
}

//   const mapDispatchToProps = { globalUpdateState }
export default connect(
  mapStateToProps,
  null
  // mapDispatchToProps
)(CustomCKEditor)
